import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
// SYSTEM1
import Loader from "@/components/widgets/loader.vue";
import Layout from "@/router/layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "@/router/views/BaseMixer";
import SectionLoader from "@/components/widgets/SectionLoader.vue";
import simplebar from "simplebar-vue";
import { TagModule } from "@/store/modules/tag.module";
import { TagReportRequestModel } from "@/store/models/tag/tagReportRequest";
import { SettingModule } from "@/store/modules/settings.module";
import EcSelect from "@/components/widgets/EcSelect.vue";
Component.registerHooks(["metaInfo"]);
let TagReport = /** @class */ (() => {
    let TagReport = class TagReport extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.title = "Tag Report";
            this.tagReport = new TagReportRequestModel();
            this.items = [
                {
                    text: "Home",
                    to: "/dashBoard",
                },
                {
                    text: "Reports",
                },
                {
                    text: "Tag Report",
                    active: true,
                },
            ];
            this.pageIsLoading = true;
            this.isPageLoading = false;
            this.isTeamLead = false;
            this.showNoData = false;
            this.selected = [];
        }
        get teams() {
            return TagModule.activeTeams;
        }
        get tagReports() {
            return TagModule.tagReport;
        }
        get tags() {
            return TagModule.allTagsForDefault;
        }
        submit() {
            this.validate("validateObserver").then((res) => {
                if (res) {
                    this.pageIsLoading = true;
                    if (this.tagReport.reportDate[0] != null && this.tagReport.reportDate != undefined) {
                        this.tagReport.startDate = this.dateFormattedString(this.tagReport.reportDate[0]);
                        this.tagReport.endDate = this.dateFormattedString(this.tagReport.reportDate[1]);
                        this.tagReport.tagIds = this.selected.map((item) => item.id.toString());
                        TagModule.GetTagReport(this.tagReport).then((res) => {
                            this.showNoData = true;
                            this.pageIsLoading = false;
                        });
                    }
                }
            });
        }
        GenerateTimeReportAsExcel() {
            this.validate("validateObserver").then((res) => {
                if (this.tagReport.reportDate[0] != null && this.tagReport.reportDate != undefined) {
                    this.tagReport.startDate = this.dateFormattedString(this.tagReport.reportDate[0]);
                    this.tagReport.endDate = this.dateFormattedString(this.tagReport.reportDate[1]);
                    this.isPageLoading = true;
                    TagModule.GetTagReportAsExcel(this.tagReport).then((res) => {
                        if (res) {
                            const blob = new Blob([res], {
                                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                            });
                            const link = document.createElement("a");
                            link.href = window.URL.createObjectURL(blob);
                            document.body.appendChild(link);
                            link.download = `TagReport.xlsx`;
                            link.click();
                            this.isPageLoading = false;
                        }
                    });
                }
            });
        }
        selectionChanged(selectedObjects) {
            if (selectedObjects.id == this.emptyGuid) {
                this.selected = [];
                this.selected.push(selectedObjects);
            }
            else {
                this.selected = this.selected.filter((x) => x.id !== selectedObjects.id);
                this.selected.push(selectedObjects);
            }
        }
        async loadTagsForTeam(teamId) {
            TagModule.ClearDefaultTags();
            await TagModule.GetTagsByTeamId(teamId);
        }
        clearReport() {
            this.showNoData = false;
            this.tagReport = new TagReportRequestModel();
            this.selected = [];
            TagModule.ClearReport();
        }
        async created() {
            this.isTeamLead = await SettingModule.IsAppUserTeamLead();
            if (this.isTeamLead) {
                TagModule.GetTeamsForTagsReport().then((res) => {
                    this.pageIsLoading = false;
                });
            }
            else {
                this.pageIsLoading = false;
            }
        }
        destroyed() {
            this.clearReport();
        }
    };
    TagReport = __decorate([
        Component({
            name: "TagReport",
            components: {
                Loader,
                Layout,
                PageHeader,
                SectionLoader,
                simplebar,
                EcSelect,
            },
        })
    ], TagReport);
    return TagReport;
})();
export default TagReport;
